import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BillingService } from '@app/shared/services/billing/billing.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
})
export class PaymentMethodsComponent implements OnInit, OnDestroy {
  loading: boolean;
  subscriptionData: any;
  canDeleteLastPaymentMethod: boolean;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private billingService: BillingService,
    private router: Router,
    private optimizelyService: OptimizelyService,
    private readonly deviceDetectionService: DeviceDetectionService
  ) { }

  ngOnInit() {
    this.loading = true;

    // If Billing is disabled in Optimizely, redirect
    this.optimizelyService.billingDisabled$.pipe(takeUntil(this.destroyed$)).subscribe((disabled) => {
      if (disabled) {
        this.router.navigate(['/settings/subscription/unavailable']);
      }
    });

    // iOS app users are not allowed to manage their subscription
    if (this.deviceDetectionService.isIosApp()) {
      this.router.navigate(['/settings/subscription/denied']);
      return;
    }

    this.checkSubscription();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  checkSubscription() {
    this.billingService.getSubscriptionDetails().subscribe((res) => {
      this.subscriptionData = res;

      // Users not on an active plan should not be here
      // Its dangerous for trial users to add a payment method without subscribing, as we'll likely bill them anyway due to how chargebee works
      // We redirect them to 'Your Plan' now instead of Subscribe, as the billing actions change with the introduction of new plans
      if (
        this.subscriptionData.status === 'trialing' ||
        this.subscriptionData.status === 'none' ||
        this.subscriptionData.status === 'ended'
      ) {
        this.router.navigate(['/settings/your-plan']);
      }

      // If the subscription is cancelled, the user can delete the last payment method
      // Otherwise one payment method must be kept on file
      if (this.subscriptionData.status === 'cancelled') {
        this.canDeleteLastPaymentMethod = true;
      }

      this.loading = false;
    });
  }
}
